import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=5bf42550&"
import script from "./CourseEdit.vue?vue&type=script&lang=js&"
export * from "./CourseEdit.vue?vue&type=script&lang=js&"
import style0 from "./CourseEdit.vue?vue&type=style&index=0&id=5bf42550&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports